import SidebarHeaderParent from './SidebarHeaderParent';

export default SidebarHeaderParent;
